import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconAlignedProps, IconRender } from '../types.ts';

const Caret = React.forwardRef<SVGSVGElement | null, IconAlignedProps>(function Caret({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M20.0339 14.4656L12.5339 6.96563C12.3917 6.82479 12.1997 6.74578 11.9995 6.74578C11.7994 6.74578 11.6074 6.82479 11.4652 6.96563L3.96516 14.4656C3.86342 14.5741 3.79445 14.7091 3.76625 14.8551C3.73804 15.0011 3.75175 15.1521 3.80579 15.2906C3.86316 15.4271 3.95966 15.5436 4.08312 15.6253C4.20658 15.7071 4.35147 15.7505 4.49954 15.75H19.4995C19.6476 15.7505 19.7925 15.7071 19.916 15.6253C20.0394 15.5436 20.1359 15.4271 20.1933 15.2906C20.2473 15.1521 20.261 15.0011 20.2328 14.8551C20.2046 14.7091 20.1357 14.5741 20.0339 14.4656Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'caret-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Caret;
